import React, { useState } from 'react';
const faqs = [{
  question: 'At what age can I start applying the protocol?',
  answer: 'From day 1 of life. The Sleep and Stimulation pillars are applicable from the first week. The protocol is designed to accompany the entire first year with specific adjustments for each stage.'
}, {
  question: 'How long does it take to see results?',
  answer: 'Many parents report improvements in sleep in less than 72 hours when implementing the Wake Windows and the 4-Element Routine. The full results of the protocol consolidate in 2-4 weeks.'
}, {
  question: 'Is it compatible with breastfeeding?',
  answer: '100%. The protocol is completely agnostic to the type of feeding. Breastfeeding is the ideal vehicle for DHA and antibodies, and the protocol is designed to enhance it, not replace it.'
}, {
  question: 'Does it work if I have twins?',
  answer: 'Yes. The key with twins is syncing their routines from the start. The Wake Windows protocol is especially critical for keeping two babies in sync and is perfectly applicable.'
}, {
  question: 'How do I receive the materials?',
  answer: 'Immediately after your purchase, you will receive an email with the download links for the main ebook and the 4 bonuses in PDF format. Access is instant, 24/7.'
}, {
  question: 'Do I need to buy special materials?',
  answer: 'No. 90% of the protocol uses what you already have at home. Your baby\'s brain and your voice are the most powerful tools. Bonus 4 "Save $2000 in their First Year" shows you exactly what you DO NOT need to buy.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-[#FAF7F2] py-16 px-5" data-id="element-39">
      <div className="max-w-[900px] mx-auto" data-id="element-40">
        <div className="text-center mb-2.5" data-id="element-41">
          <span className="inline-block bg-[rgba(183,110,121,0.1)] text-[#B76E79] text-[11px] tracking-widest uppercase px-4 py-1.5 rounded-full font-sans font-bold" data-id="element-42">
            We answer your questions
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl text-[#3D2B1F] mb-12 leading-tight text-center" data-id="element-43">
          Frequently Asked Questions
        </h2>

        <div className="max-w-[750px] mx-auto space-y-3" data-id="element-44">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-xl overflow-hidden shadow-sm" data-id="element-45">
              <button onClick={() => toggleFAQ(idx)} className="w-full bg-transparent p-5 flex justify-between items-center text-base text-[#3D2B1F] font-semibold text-left transition-colors hover:bg-[#FAF7F2]" data-id="element-46">
                <span className="pr-4" data-id="element-47">{faq.question}</span>
                <span className={`text-2xl text-[#B76E79] flex-shrink-0 transition-transform ${openIndex === idx ? 'rotate-45' : ''}`} data-id="element-48">
                  +
                </span>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === idx ? 'max-h-96 pb-5' : 'max-h-0'}`} data-id="element-49">
                <p className="px-6 text-sm text-[#6B4C3B] font-sans leading-relaxed" data-id="element-50">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}